import { useRouter } from "next/router";
import CustomChips from "../CustomChips";
import RenderFilterLabels from "./RenderFilterLabels";
import classes from "./transaction-history-container.module.css";
import { Routes } from "../../routes/RouteConstants";
import DateFilter from "./DateFilter";
import LogService from "../../services/LogService";
import CREDIT_EVENTS from "../../utils/CreditEvents";

function Filters(props) {
  const router = useRouter();
  const { query } = router;
  const { dateFilter = null, tabs = [] } = props;
  const updatedTabs = tabs.filter(tab => tab.count);
  function onTabSelect({ chipValue }) {
    const queryParams = { ...query, tabId: chipValue, page: 1 };
    router.push({
      pathname: Routes.TRANSACTION_HISTORY,
      query: queryParams
    });
    LogService.log(CREDIT_EVENTS.TH_TAB_CLICKED, { tabId: chipValue });
  }

  return (
    <div className={classes.filters}>
      <DateFilter dateFilter={dateFilter} />
      <div className={classes.tabsContainer}>
        <div className={classes.tabs}>
          {updatedTabs.map(item => (
            <CustomChips
              key={item.id}
              id={`subtab-${item.id}`}
              chipLabel={<RenderFilterLabels item={item} />}
              chipValue={item.id}
              chipObject={item}
              valueKey="id"
              panel="tabList"
              onChipSelect={onTabSelect}
              isMultiSelect={false}
              customClass={classes.tab}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default Filters;
